function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1691",
  "data-name": "Path 1691",
  d: "M39.886,0A26.146,26.146,0,1,1,13.74,26.146,26.146,26.146,0,0,1,39.886,0Zm0,8.313A17.833,17.833,0,1,1,22.053,26.146,17.833,17.833,0,0,1,39.886,8.313Z",
  transform: "translate(-13.74)",
  fill: "#f86542",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1692",
  "data-name": "Path 1692",
  d: "M44.749,18.09A12.919,12.919,0,1,1,31.83,31.009,12.918,12.918,0,0,1,44.749,18.09Z",
  transform: "translate(-18.603 -4.863)",
  fill: "#f86542",
  fillRule: "evenodd"
});

var SvgLogoCircleAgrotech = function SvgLogoCircleAgrotech(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4349",
    "data-name": "Group 4349",
    width: 52.292,
    height: 52.292,
    viewBox: "0 0 52.292 52.292",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoCircleAgrotech, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-circle-agrotech.ecaecc08.svg";
export { ForwardRef as ReactComponent };